export default {
    install(app) {

        const regionName = import.meta.env.VITE_REGION_NAME;
        const isSouthEast = () => regionName === 'South East';
        const isSouthWest = () => regionName === 'South West';

        app.config.globalProperties.isSouthEast = isSouthEast;
        app.provide('isSouthEast', isSouthEast);
        app.config.globalProperties.isSouthWest = isSouthWest;
        app.provide('isSouthWest', isSouthWest);
    }
    
};